import React, { useState } from "react";
import { Button, Card, Col, Row, Tabs, TabsProps } from "antd";
import { TableDataManagement } from "./components/table-datamanagement";
import { PlusOutlined, RightCircleFilled } from "@ant-design/icons";
import { FooterDataManagement } from "./components/footer-datamanagement";
import { useHistory } from "react-router-dom";
import { TableDataManagementUnlist } from "./components/table-datamanagement-unlist";
interface Props {
  baseUrl: string;
  accessRole: any;
}
export const MainDataManagement: React.FC<Props> = ({ baseUrl, accessRole }): React.ReactElement => {
  const { push } = useHistory();
  const [tabActive, setTabActive] = useState<string>("ALL");
  const [loading, setLoading] = useState<boolean>(true);

  const items: TabsProps["items"] = [
    {
      key: "ALL",
      label: (
        <>
          <RightCircleFilled width="8" style={{ color: "#000000" }} />
          All
        </>
      ),
      children: <TableDataManagement baseUrl={baseUrl} tab={{ key: "", label: "All" }} />,
    },
    {
      key: "DRAFT",
      label: (
        <>
          <RightCircleFilled width="8" style={{ color: "#FAAD14" }} />
          Draft
        </>
      ),
      children: <TableDataManagement baseUrl={baseUrl} tab={{ key: "DRAFT", label: "Draft" }} />,
    },
    // {
    //   key: "WAITING_APPROVAL",
    //   label: (
    //     <>
    //       <RightCircleFilled width="8" style={{ color: "#1890FF" }} />
    //       Waitting Approvel
    //     </>
    //   ),
    //   children: <TableDataManagement baseUrl={baseUrl} tab={{ key: "WAITING_APPROVAL", label: "Waiting Approval" }} />,
    // },
    {
      key: "APPROVED",
      label: (
        <>
          <RightCircleFilled width="8" style={{ color: "#52C41A" }} />
          Approved
        </>
      ),
      children: <TableDataManagement baseUrl={baseUrl} tab={{ key: "APPROVED", label: "Approved" }} />,
    },
    {
      key: "DISABLED",
      label: (
        <>
          <RightCircleFilled width="8" style={{ color: "#FF4D4F" }} />
          Disabled
        </>
      ),
      children: <TableDataManagement baseUrl={baseUrl} tab={{ key: "DISABLED", label: "Disabled" }} />,
    },
    {
      key: "UNLIST",
      label: (
        <>
          <RightCircleFilled width="8" style={{ color: "#808080" }} />
          Unlist
        </>
      ),
      children: (
        <TableDataManagementUnlist
          baseUrl={baseUrl}
          tab={{ key: "UNLIST", label: "Unlist" }}
          loading={loading}
          setLoading={setLoading}
          accessRole={accessRole}
        />
      ),
    },
  ];
  const onChange = async (key: string) => {
    setTabActive(key);
  };

  return (
    <>
      <Card style={{ width: "100%", marginTop: "30px" }}>
        <Row gutter={[8, 8]}>
          <Col md={24} style={{ width: "100%", justifyContent: "end", display: "flex" }}>
            <Button
              type="primary"
              onClick={(e) => {
                push(`datamanagement/addcondition/new`);
              }}
            >
              <PlusOutlined />
              {`Add Condition`}
            </Button>
          </Col>
          <Col md={24}>
            <Tabs style={{ width: "100%" }} tabPosition={"left"} items={items} onChange={onChange} />
          </Col>
          <Col md={24}>{tabActive === "APPROVED" ? <FooterDataManagement /> : <></>}</Col>
        </Row>
      </Card>
    </>
  );
};
